module.exports = __webpack_public_path__ + "img/asset_ok_off.288a00ff.svg";